import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import Screen from 'src/Libs/installation-statement/components/Modals/ModalState/Screen'
import { Box, Button } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useNavigate } from 'react-router-dom'
import { getThemedBlankViewImage } from 'src/Libs/utils'
import { BlankViewImageVariants } from 'src/Components/blank-view'
import { useFarmContext } from 'src/Elements/Farm'

const useStyles = makeStyles()(theme => ({
  callToActionContainer: {
    display: 'flex',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    justifyContent: 'center',
  },
}))

interface Props {
  onClose: () => void
  installationId: number
  deviceId: string
}

const SaveSuccess: React.FC<Props> = ({ onClose, installationId, deviceId }) => {
  const { t } = useCustomTranslation()
  const { farmMaster } = useFarmContext()
  const { classes } = useStyles()
  const navigate = useNavigate()
  const blankViewHappyImage = getThemedBlankViewImage(BlankViewImageVariants.Happy)
  const handleClick = (): void => {
    onClose()
    navigate(`/dashboard/documents/${installationId}/${farmMaster?.storageId ?? deviceId}`)
  }

  return (
    <Screen
      title={t('installation-statement.modal-state.save-success.title')}
      body={t('installation-statement.modal-state.save-success.body')}
      imageSource={blankViewHappyImage}
      hasFooter={true}
      onClose={onClose}
      callToActionComponent={
        <Box className={classes.callToActionContainer}>
          <Button variant="contained" onClick={handleClick}>
            {t('installation-statement.modal-state.save-success.documents-link')}
          </Button>
        </Box>
      }
    />
  )
}

export default SaveSuccess
